import { createContext, useContext } from 'react';

type ExitTransition = {
  isExiting: boolean;
  startExit: () => void;
};

// Owned by OnboardingLayout so the gradient animates outside the blurred step container. Steps
// that redirect to the dashboard start the exit, then stagger their own content out alongside it.
const ExitTransitionContext = createContext<ExitTransition>({ isExiting: false, startExit: () => { } });

export const ExitTransitionProvider = ExitTransitionContext.Provider;

export function useExitTransition(): ExitTransition {
  return useContext(ExitTransitionContext);
}

export const EXIT_ITEM_DURATION = 0.6;
export const EXIT_ITEM_STAGGER = 0.09;

export const exitItemVariants = {
  opacity: 0,
  y: -28,
  filter: 'blur(10px)',
};
